module.exports = __webpack_public_path__ + "static/media/people-fill-primary.883cf51c.svg";